import styled from "styled-components";
import { NB_sidebar_props } from "../interface";

interface ExtendedSidebarProps extends NB_sidebar_props {
  isHidden?: boolean;
  bgColorHeader?: string;
  isHiddenList?: boolean;
  isActive?: boolean;
  color?: string;
}

const filterProps = (prop: string) =>
  ![
    "isHidden",
    "bgColorHeader",
    "backgroundColor",
    "isHiddenList",
    "isActive",
  ].includes(prop);

export const Container = styled.section.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 64px;
`;

export const HeaderSidebar = styled.article.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: ${(props) => (props.isHidden ? "calc(72px + 1px)" : "240px")};
  height: 64px;
  left: 0;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: ${(props) => (props.isHidden ? "center" : "space-between")};
  background-color: ${(props) => props.bgColorHeader || "#FFFFFF"};
  transition: width 0.7s ease-in-out, justify-content 0.7s ease-in-out;
  box-sizing: inherit;
`;

export const SidebarContainer = styled.article.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: ${(props) => (props.isHidden ? "calc(72px + 1px)" : "240px")};
  height: calc(100vh - 64px);
  margin-top: 64px;
  left: 0;
  transition: width 0.7s ease-in-out;
  display: flex;
  flex-direction: column;
  position: fixed;
  background-color: ${(props) => props.backgroundColor || "#FFFFFF"};
  overflow: hidden;
`;

export const ContainerLogo = styled.div.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: ${(props) => (props.isHidden ? "0" : "66%")};
  height: 57px;
  overflow: hidden;
  margin: 0 0px 0px 10px;
  transition: width 0.7s ease-in-out;
`;

export const ContainerIcon = styled.div.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 35px;
  height: 35px;
  cursor: pointer;
`;

export const ContainerIconList = styled.div.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 25px;
  height: 25px;
`;

export const LogoImg = styled.img.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: ${(props) => {
    return props.isActive ? props.color : "transparent";
  }};
  padding: 2px;
  border-radius: 4px;
`;

export const LogoImg2 = styled.img.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 30px;
  object-fit: cover;
  object-position: 4px;
  height: 22px;
  margin: 4px 0 0 0;
`;

export const Ul = styled.ul.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const LiItem = styled.li.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => (props.isHidden ? "0" : "8px")};
  cursor: pointer;
  position: relative;
  background-color: ${(props) =>
    props.isActive ? props.color || "#E9F3FF" : "transparent"};
  &:hover {
    background-color: ${(props) =>
      props.isActive ? props.color || "#E9F3FF" : "#f5f5f5"};
  }
  transition: gap 0.7s ease-in-out;
`;

export const TitleIconHeaderContainer = styled.div.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: ${(props) => (props.isHidden ? "0" : "185px")};
  display: flex;
  align-items: center;
  transition: width 0.7s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
`;

export const TitleItemHeader = styled.p.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  min-width: 155px;
  max-width: auto;
  margin: 0;
  padding: 0;
  font-family: "Host Grotesk", Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 1.5;
  color: ${(props) => (props.isActive ? "#18181B" : "#3F3F46")};
  white-space: nowrap;
  overflow: hidden;
`;

export const ChildListItemContainer = styled.div.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: ${(props) => (props.isHiddenList ? "0" : "auto")};
  opacity: ${(props) => (props.isHiddenList ? "0" : "1")};
  overflow: hidden;
  padding-left: ${(props) => (props.isHidden ? "0" : "40px")};
  transition: max-height 0.7s ease-in-out, opacity 0.7s ease-in-out;
`;

export const TitleItem = styled.p.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: ${(props) => (props.isHidden ? "0" : "185px")};
  margin: 0;
  padding: 0;
  font-family: Host Grotesk !important;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: ${(props) => (props.isActive ? "#18181B" : "#3F3F46")};
  transition: width 0.7s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
`;

export const ActiveIndicator = styled.div.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 4px;
  height: 24px;
  display: ${(props) => (props.isActive ? "block" : "none")};
  background-color: #0076ff;
  position: absolute;
  right: 0;
  border-radius: 4px 0px 0px 4px;
`;
